import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import './AddIncidentModal.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const AddIncidentModal = ({ show, onHide, onConfirm, userEmail }) => {
    const { customerId } = useParams();
    const [incidentDate, setIncidentDate] = useState(new Date());
    const [incidentType, setIncidentType] = useState("");
    const [incident, setIncident] = useState("");
    const [error, setError] = useState(null);
    const [confirmationMessage, setConfirmationMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        if (show) {
            setIncidentDate(new Date());
            setIncidentType("");
            setIncident("");
            setError(null);
            setConfirmationMessage("");
            setIsSubmitting(false);
        }
    }, [show]);

    const handleConfirm = () => {
        if (!incidentType) {
            setError("Please select an incident type.");
            return;
        }
        if (!incident.trim()) {
            setError("Please enter incident details.");
            return;
        }

        // Validate incidentDate - ensure it's a valid date
        let validIncidentDate = incidentDate instanceof Date && !isNaN(incidentDate)
            ? incidentDate
            : new Date();

        const payload = {
            customerId: customerId,
            validIncidentDate: validIncidentDate.toISOString().split('T')[0], // Just the date part YYYY-MM-DD
            incidentType: incidentType,
            incident: incident.trim(),
            email: userEmail || '',
        };

        submitIncidentData(payload);
    };

    const submitIncidentData = (payload) => {
        setError(null);
        setIsSubmitting(true);
        fetch(`${BASE_URL}api/ProspCustomers/AddCustomerIncident`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to submit incident data to the backend');
                }
                return response.json();
            })
            .then(data => {
                setIsSubmitting(false);
                setConfirmationMessage("Incident added successfully!");
                onConfirm();
                // Reset form after successful submission
                setTimeout(() => {
                    onHide();
                }, 1500);
            })
            .catch(error => {
                setIsSubmitting(false);
                setError(error.message);
            });
    };

    const handleClose = () => {
        onHide();
    };

    return (
        <div className={`add-incident-modal-overlay${show ? '' : ' d-none'}`}> 
            <div className="add-incident-modal-content">
                <span style={{ float: "right", cursor: "pointer" }} onClick={handleClose}>
                    &times;
                </span>
                <h3 className="modal-title add-incident-title">
                    📝 Add Incident
                </h3>
                
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label htmlFor="incidentDate" className="form-label">Date:</label>
                        <DatePicker
                            id="incidentDate"
                            selected={incidentDate}
                            onChange={date => setIncidentDate(date)}
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                            isClearable={false}
                        />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="incidentType" className="form-label">Incident Type:</label>
                        <select
                            id="incidentType"
                            className="form-select"
                            value={incidentType}
                            onChange={e => setIncidentType(e.target.value)}
                        >
                            <option value="" disabled>Select Incident Type</option>
                            <option value="Visit">Visit</option>
                            <option value="Telephone Call">Telephone Call</option>
                            <option value="Whatsapp">Whatsapp</option>
                            <option value="Email">Email</option>
                        </select>
                    </div>
                </div>
                
                <div className="mb-3">
                    <label htmlFor="incident" className="form-label">Incident:</label>
                    <textarea
                        id="incident"
                        className="form-control"
                        rows={4}
                        value={incident}
                        onChange={e => setIncident(e.target.value)}
                        placeholder="Enter incident details..."
                    />
                </div>
                
                <div className="d-flex justify-content-end mt-4">
                    <button className="btn btn-primary me-2" onClick={handleConfirm} disabled={isSubmitting}>
                        {isSubmitting ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Adding...
                            </>
                        ) : (
                            "Add Incident"
                        )}
                    </button>
                    <button className="btn btn-secondary" onClick={handleClose} disabled={isSubmitting}>
                        Cancel
                    </button>
                </div>
                {error && <div className="mt-3 alert alert-danger">{error}</div>}
                {confirmationMessage && <div className="mt-3 alert alert-success">{confirmationMessage}</div>}
                {/* Responsive gap styling */}
                <style>{`
                  .add-incident-modal-gap { margin-bottom: 2rem; }
                  @media (max-width: 576px) {
                    .add-incident-modal-gap { margin-bottom: 0.75rem; }
                  }
                `}</style>
            </div>
        </div>
    );
};

export default AddIncidentModal; 